import { DTO } from '../DTO'

export class SmsSummary extends DTO {
  success: number
  fail: number
  requested: number

  constructor(data) {
    super()
    this.success = data.success
    this.fail = data.fail
    this.requested = data.requested
  }
}
